import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=fbe77cc2&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=fbe77cc2&prod&scoped=true&lang=css"
import style1 from "./ProductsTable.vue?vue&type=style&index=1&id=fbe77cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe77cc2",
  null
  
)

export default component.exports